import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './info.module.scss';

const METADATA = Metadata.define({
  description: 'Secondary info badge indicator.',
  name: 'Info Secondary Badge',
});

export default class SpdsIndicatorBadgeInfoSecondary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  secondary = true;
  variantClass = 'spds-indicator-badge-info';
  variantStyles = styles;
}

export const BADGE_INFO_SECONDARY_METADATA = SpdsIndicatorBadgeInfoSecondary.metadata;
